// components/AdditionalSection.jsx
import React from "react";
import { useLocalization } from "../../../../context/LocalizeContextProvider";
import { useModal } from "../../../../context/ModalProvider";
import Button from "../../Button";
import { formatNumberWithCurrency } from "../../../../utils/utils";
import styles from "../ModalDetailReservationV2.module.css";

const AdditionalItem = ({
  session = 0,
  name = "Treatment Kulit",
  id,
  package_id,
  deposit_id, // Add this for deposits
  price = 300000,
  handleUndoUsed = () => undefined,
  tooltipCancelActive = "Batalkan Aktifkan",
  isUsed = false,
  // Package specific props
  isPackageSection = false,
  isDepositSection = false, // Add this flag
  isUsedInReservation = false,
  handleUsePackage = () => undefined,
  handleDeletePackage = () => undefined,
  handleUndoUsedPackage = () => undefined,
  handleUseDeposit = () => undefined, // Add deposit handlers
  handleUndoUsedDeposit = () => undefined,
  isReservation = false,
  disabled = false,
}) => {
  const modal = useModal();
  const localize = useLocalization();

  const handlePackageUse = () => {
    if (isPackageSection && package_id) {
      handleUsePackage(package_id);
    } else if (isDepositSection && deposit_id) {
      handleUseDeposit(deposit_id);
    }
  };

  const handlePackageDelete = () => {
    if (isPackageSection && id) {
      modal.showConfirmation({
        title: localize.getText("areYouSure"),
        message: localize.getText("cancelledDataWarning"),
        onConfirm: () => handleDeletePackage(id),
      });
    }
  };

  const handlePackageUndo = () => {
    if (isPackageSection && package_id) {
      modal.showConfirmation({
        title: localize.getText("areYouSure"),
        message: localize.getText("undoActivedPackage"),
        onConfirm: () => handleUndoUsedPackage(package_id),
      });
    } else if (isDepositSection && deposit_id) {
      modal.showConfirmation({
        title: localize.getText("areYouSure"),
        message: localize.getText("undoActivedDeposit"),
        onConfirm: () => handleUndoUsedDeposit(deposit_id),
      });
    }
  };

  return (
    <div className={styles.additionalItem}>
      <div className={styles.additionalItemContent}>
        <div className={styles.additionalItemInfo}>
          <p className={styles.additionalItemName}>{name}</p>
          {!session && (
            <p className={styles.additionalItemPrice}>
              {formatNumberWithCurrency(price)}
            </p>
          )}
        </div>
        {!!session && (
          <div className={styles.additionalItemInfo}>
            <div className={styles.additionalItemSession}>
              <p className={styles.additionalItemSessionText}>
                {"Sisa"} {session}
              </p>
            </div>
            <p className={styles.additionalItemPrice}>
              {formatNumberWithCurrency(price)}
            </p>
          </div>
        )}
      </div>

      {!disabled && (
        <div className="d-flex align-items-center gap-2 w-100">
          {/* Use button - works for both packages and deposits */}
          {isPackageSection || isDepositSection ? (
            <>
              {isReservation ? (
                <Button
                  leftIcon={
                    isUsedInReservation ? (
                      <i className="fas fa-check" />
                    ) : (
                      <i className="fas fa-toggle-off" />
                    )
                  }
                  label={
                    isUsedInReservation
                      ? localize.getText("use")
                      : localize.getText("notUse")
                  }
                  onClick={handlePackageUse}
                  variant={isUsedInReservation ? "primary" : "dark light"}
                  size="sm"
                  fullWidth
                />
              ) : (
                <Button
                  label={
                    isUsed ? localize.getText("used") : localize.getText("use")
                  }
                  onClick={handlePackageUse}
                  disabled={isUsed}
                  size="sm"
                  fullWidth
                />
              )}
            </>
          ) : (
            // Regular deposit section button (fallback)
            <Button
              label={
                isUsed ? localize.getText("used") : localize.getText("use")
              }
              size="sm"
              fullWidth
              disabled={isUsed}
            />
          )}

          {/* Undo button - works for both packages and deposits */}
          {(isPackageSection || isDepositSection) && isUsed && (
            <Button
              onClick={handlePackageUndo}
              tooltip={tooltipCancelActive}
              variant="info"
              size="sm"
            >
              <i className="fas fa-undo" />
            </Button>
          )}

          {/* Delete button - ONLY for packages, NOT for deposits */}
          {isPackageSection && !isReservation && (
            <Button
              variant="danger"
              tooltip={localize.getText("deletePackage")}
              onClick={handlePackageDelete}
              size="sm"
            >
              <i className="fas fa-trash" />
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

const AdditionalSection = ({
  title,
  iconClass,
  items = [],
  tooltipCancelActive,
  isPackageSection = false,
  isDepositSection = false, // Add this prop
  isReservation = false,
  disabled = false,
}) => {
  return (
    <div className={styles.additionalSection}>
      <div className={styles.additionalSectionHeader}>
        <i className={`${iconClass} ${styles.sectionIcon}`} />
        <p className={styles.sectionTitle}>{title}</p>
      </div>
      {items.length > 0 ? (
        items.map((item, index) => (
          <AdditionalItem
            key={index}
            {...item}
            disabled={disabled}
            tooltipCancelActive={tooltipCancelActive}
            isPackageSection={isPackageSection}
            isDepositSection={isDepositSection} // Pass this down
            isReservation={isReservation}
          />
        ))
      ) : (
        <div className={styles.emptyState}>
          <p className={styles.emptyStateText}>
            Tidak ada {title.toLowerCase()} tersedia
          </p>
        </div>
      )}
    </div>
  );
};

export default AdditionalSection;
